export default "__VITE_ASSET__CRcGjdjz__"